import { Component, EventEmitter, Input, Output } from '@angular/core';
import { WizardCreationType } from '@models/Dashboard/dashboardWizard.model';

// One selectable option in the first wizard step. leadLabel is the bold lead
// word(s) and restLabel the remainder, matching the mockup ("Chart Readings",
// "Geo Map Sensors and Readings", ...).
interface CreateTypeOption {
  type: WizardCreationType;
  leadLabel: string;
  restLabel: string;
  icon: string;        // Font Awesome icon class
  enabled: boolean;
}

// Step 1: "What to create?". A data-driven list of options. Chart, Map and Image
// Favorite and Notification are enabled; the others are disabled with a "coming soon" tooltip and
// will be lit up as each per-type flow is built.
@Component({
  standalone: false,
  selector: 'wizard-step-create-type',
  templateUrl: './wizard-step-create-type.component.html',
  styleUrls: ['./wizard-step-create-type.component.scss']
})
export class WizardStepCreateTypeComponent {
  @Input() selectedType: WizardCreationType = null;
  @Output() selectedTypeChange = new EventEmitter<WizardCreationType>();

  readonly options: CreateTypeOption[] = [
    { type: WizardCreationType.ChartReadings,            leadLabel: 'Chart',      restLabel: 'Favorite',             icon: 'fa-chart-line',       enabled: true },
    { type: WizardCreationType.GeoMapSensorsReadings,    leadLabel: 'Map',        restLabel: 'Favorite',             icon: 'fa-map-location-dot', enabled: true },
    { type: WizardCreationType.ImageMapReadings,         leadLabel: 'Image',      restLabel: 'Favorite',             icon: 'fa-image',            enabled: true },
    { type: WizardCreationType.DataTableReadings,        leadLabel: 'Data Table', restLabel: 'of Sensor Readings',   icon: 'fa-table',            enabled: false },
    { type: WizardCreationType.TriggerConditionsActions, leadLabel: 'Notification', restLabel: '',                    icon: 'fa-bolt',             enabled: true }
  ];

  select(option: CreateTypeOption): void {
    if (!option.enabled) {
      return;
    }
    this.selectedType = option.type;
    this.selectedTypeChange.emit(option.type);
  }
}
